var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_222)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4883 8.04234L13.3172 10.8098L14.2671 14.9302C14.3699 15.3705 14.199 15.8296 13.8333 16.0956C13.4676 16.3616 12.9782 16.3828 12.5909 16.1494L8.99719 13.9697L5.41125 16.1494C5.02394 16.3828 4.53452 16.3616 4.16882 16.0956C3.80312 15.8296 3.63223 15.3705 3.735 14.9302L4.68352 10.8141L1.51172 8.04234C1.16872 7.74652 1.03658 7.27384 1.17645 6.84303C1.31632 6.41222 1.70091 6.1073 2.15227 6.06938L6.33305 5.70727L7.965 1.81477C8.13926 1.39712 8.54746 1.12514 9 1.12514C9.45254 1.12514 9.86074 1.39712 10.035 1.81477L11.6719 5.70727L15.8512 6.06938C16.3026 6.1073 16.6872 6.41222 16.8271 6.84303C16.9669 7.27384 16.8348 7.74652 16.4918 8.04234H16.4883Z",
    fill: "#F5C754"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star-filled.39853d32cb6e8980ead69f0ad4e99def.svg";
export { ForwardRef as ReactComponent };